export default __webpack_public_path__ + "static/results-light-435f08e30e887f9714468daaa4095623.png";